/**
 * HubSpot tracking helpers.
 *
 * The embed script lives in `index.html` so HubSpot's installer can detect it
 * in page source. This module only handles SPA page-view updates after load.
 */

declare global {
  interface Window {
    _hsq?: Array<unknown[]>;
  }
}

export function trackHubSpotPageView(path?: string): void {
  if (typeof window === "undefined") return;
  const pathname = path ?? `${window.location.pathname}${window.location.search}`;
  window._hsq = window._hsq || [];
  window._hsq.push(["setPath", pathname]);
  window._hsq.push(["trackPageView"]);
}
